import React, { useEffect } from 'react';
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, ROLES } from './AuthContext'; // Správný import

function ProtectedRoute({ children }) {
  const { currentUser, isAuthenticated } = useAuth();
  const location = useLocation();

  // Seznam ID rolí, které patří interním uživatelům
  const INTERNAL_ROLE_IDS = Object.values(ROLES);
  const isInternalUser = currentUser && currentUser.roleId && INTERNAL_ROLE_IDS.includes(currentUser.roleId);

  // Ask backend for correct redirect (env-driven) when user is external
  useEffect(() => {
    if (!isAuthenticated) return;
    if (isInternalUser) return;
    
    // PREVIEW MODE: Pokud je preview_contact parametr, NE-směruj externího uživatele
    const searchParams = new URLSearchParams(location.search);
    const previewContact = searchParams.get('preview_contact');
    if (previewContact) {
      console.log('[ProtectedRoute] Preview mode detected - skipping external redirect');
      return;
    }
    
    const redirectExternal = async () => {
      try {
        const params = new URLSearchParams({ returnTo: location.pathname + location.search });
        const resp = await fetch(`/server/portal_auth/redirect_target?${params.toString()}`, { credentials: 'include' });
        const data = await resp.json();
        if (data?.url) {
          window.location.replace(data.url);
        } else {
          window.location.replace('/login');
        }
      } catch (e) {
        window.location.replace('/login');
      }
    };
    redirectExternal();
  }, [isAuthenticated, isInternalUser, location.pathname, location.search]);

  // Pokud uživatel ještě není ověřen (načítá se), přesměrujeme na login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Zkontrolovat preview mode
  const searchParams = new URLSearchParams(location.search);
  const previewContact = searchParams.get('preview_contact');

  // Zde je klíčová logika:
  // Internal users NEBO preview mode → stay in-app
  if (isInternalUser || previewContact) {
    return children; 
  }

  // Render nothing during redirection
  return null;
}

export default ProtectedRoute;